<template>
    <div>
        <v-data-table
            :headers="headers"
            :items="filterRequests"
            class="elevation-0"
            :mobile-breakpoint="0"
            :loading="loading"
            disable-pagination
            hide-default-footer
            @click:row="openRequest"
            fixed-header
        >
            <template v-slot:top>
                <div class="top">
                    <v-row
                        no-gutter
                        class="mt-0 mx-0 pt-4 pb-0 pb-4 align-center"
                        :style="{ 'background-color': '#eeeeee' }"
                    >
                        <v-spacer />
                        <v-menu
                            bottom
                            offset-y
                            class="purchasing-approval-menu"
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                    class="d-flex align-center mr-4"
                                    elevation="4"
                                    :disabled="loading"
                                    icon
                                    title="Actions"
                                    color="primary"
                                    v-bind="attrs"
                                    v-on="on"
                                >
                                    <v-icon>mdi-dots-horizontal</v-icon>
                                </v-btn>
                            </template>
                            <v-list>
                                <v-list-item
                                    v-for="(item, i) in optionsMenu"
                                    :key="i"
                                    @click="selectFunction(item)"
                                >
                                    <v-list-item-icon>
                                        <v-icon class="mr-1">{{
                                            item.icon
                                        }}</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-title>{{
                                        item.title
                                    }}</v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                    </v-row>
                </div>
            </template>
            <!--HEADERS-->
            <template v-slot:[`header.number`]="{ header }">
                <v-text-field
                    :label="header.text"
                    v-model="idToFilter"
                    dense
                    class="pt-2"
                />
            </template>
            <template v-slot:[`header.createdBy`]="{ header }">
                <v-text-field
                    :label="header.text"
                    v-model="usersToFilter"
                    dense
                    class="pt-2"
                />
            </template>
            <template v-slot:[`header.project`]="{ header }">
                <v-text-field
                    :label="header.text"
                    v-model="projectToFilter"
                    dense
                    class="pt-2"
                />
            </template>
            <template v-slot:[`header.deliveryLocation`]="{ header }">
                <v-text-field
                    :label="header.text"
                    v-model="locationToFilter"
                    dense
                    class="pt-2"
                />
            </template>
            <template v-slot:[`header.date`]="{ header }">
                <v-text-field
                    :label="header.text"
                    v-model="dateToFilter"
                    dense
                    class="pt-2"
                />
            </template>
            <template v-slot:[`header.dueDate`]="{ header }">
                <v-text-field
                    :label="header.text"
                    v-model="dueDateToFilter"
                    dense
                    class="pt-2"
                />
            </template>
            <template v-slot:[`header.items`]="{ header }">
                <v-text-field
                    :label="header.text"
                    v-model="itemsToFilter"
                    dense
                    class="pt-2"
                />
            </template>
            <template v-slot:[`header.notes`]="{ header }">
                <v-text-field
                    :label="header.text"
                    v-model="notesToFilter"
                    dense
                    class="pt-2"
                />
            </template>
            <!--ITEMS-->
            <template v-slot:[`item.select`]="{ item }">
                <div class="d-flex justify-center ma-0 pa-0">
                    <v-checkbox
                        v-model="selectedPurchasesToApprove"
                        :value="item.id"
                        hide-details
                        @click.stop
                    ></v-checkbox>
                </div>
            </template>
            <template v-slot:[`item.createdBy`]="{ item }">
                <div class="my-0">
                    <div>
                        <v-tooltip right>
                            <template v-slot:activator="{ on, attrs }">
                                <p
                                    class="my-0 font-weight-medium"
                                    v-bind="attrs"
                                    v-on="on"
                                >
                                    {{ item.createdBy.name }}
                                </p>
                            </template>
                            <span>Creator</span>
                        </v-tooltip>
                    </div>
                    <div v-if="item.projectManager">
                        <v-tooltip right>
                            <template v-slot:activator="{ on, attrs }">
                                <p
                                    class="my-0 font-weight-medium"
                                    v-bind="attrs"
                                    v-on="on"
                                >
                                    {{ item.projectManager.name }}
                                </p>
                            </template>
                            <span>Project Manager</span>
                        </v-tooltip>
                    </div>
                    <div v-if="item.buyer">
                        <v-tooltip right>
                            <template v-slot:activator="{ on, attrs }">
                                <p
                                    class="my-0 font-weight-medium"
                                    v-bind="attrs"
                                    v-on="on"
                                >
                                    {{ getUser(item.buyer) }}
                                </p>
                            </template>
                            <span>Buyer</span>
                        </v-tooltip>
                    </div>
                </div>
            </template>
            <template v-slot:[`item.date`]="{ item }">
                <p class="my-0 text-capitalize">
                    {{ formatDate(item.createdOn.seconds) }}
                </p>
            </template>
            <template v-slot:[`item.projectManager`]="{ item }">
                <p class="my-0 text-capitalize">
                    {{ item.projectManager.name }}
                </p>
            </template>
            <template v-slot:[`item.project`]="{ item }">
                <p class="my-0 text-capitalize">{{ item.project.name }}</p>
            </template>
            <template v-slot:[`item.items`]="{ item }">
                <div>
                    <p
                        class="my-0"
                        v-for="(element, index) of item.items"
                        :key="index"
                    >
                        {{ element.description }} ({{ element.quantity }})
                    </p>
                </div>
            </template>
            <template v-slot:[`item.totalPrice`]="{ item }">
                <div class="d-flex justify-center">
                    <p class="my-0">{{ formatNumber(calculateTotal(item)) }}</p>
                </div>
            </template>
            <template v-slot:[`item.actions`]="{ item }">
                <v-menu rounded offset-y>
                    <template v-slot:activator="{ attrs, on }">
                        <v-btn icon v-bind="attrs" v-on="on" small class="mx-1">
                            <v-icon>mdi-dots-vertical</v-icon>
                        </v-btn>
                    </template>
                    <v-list>
                        <v-list-item @click="openTimeLineDialog(item)">
                            <v-list-item-title>
                                Timeline
                            </v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>
            </template>
        </v-data-table>
        <!--ALERT MESSAGES-->
        <v-alert
            v-if="activateAlert"
            type="success"
            color="primary"
            :style="{ position: 'absolute', right: '0px', bottom: '0px' }"
        >
            <v-row no-gutters>
                <v-col cols="11">
                    <p class="my-0">{{ alertMessage }}</p>
                </v-col>
                <v-col cols="1">
                    <v-btn
                        small
                        icon
                        class="mt-n1"
                        @click="activateAlert = false"
                    >
                        <v-icon>
                            mdi-close
                        </v-icon>
                    </v-btn>
                </v-col>
            </v-row>
        </v-alert>
        <!--Request Form-->
        <v-dialog persistent fullscreen v-model="openForm">
            <PurchaseRequest
                v-if="openForm"
                :localRequest="selectedRequest"
                :originalRequest="originalRequest"
                :createForm="createForm"
                :step="step"
                :purchaseApproverProjects="effectivePurchaseApproverProjects"
                @closeDialog="closeRequestForm"
                @replaceRequest="replaceRequest"
                @approveForPurchase="approveForPurchase"
                @rejectRequest="rejectRequest"
            />
        </v-dialog>
        <v-dialog
            v-model="validateGroupDialog"
            persistent
            max-width="600"
            @input="onValidateGroupDialogClose"
        >
            <v-card class="pb-2" :loading="validatingGroup">
                <v-card-title class="headline">
                    <v-btn
                        small
                        icon
                        @click="closeValidateGroupDialog"
                        class="mr-2 ml-n3"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    VALIDATE PURCHASES TO APPROVE
                </v-card-title>
                <v-card-text class="pb-1 pt-3">
                    <v-list dense>
                        <v-list-item
                            v-for="(task, index) in validateGroupTasks"
                            :key="index"
                            class="pa-0"
                        >
                            <v-list-item-content class="pa-0">
                                <v-list-item-title class="d-flex">
                                    <p class="mr-4 text-body-1 mb-0">
                                        <v-icon class="mr-2">{{
                                            task.icon
                                        }}</v-icon>
                                        {{ task.name }}
                                    </p>
                                    <div>
                                        <v-progress-circular
                                            v-if="task.loading"
                                            indeterminate
                                            size="24"
                                            width="2"
                                        />
                                        <v-icon
                                            v-else-if="
                                                task.checked && task.warning
                                            "
                                            color="warning"
                                        >
                                            mdi-alert-circle-outline
                                        </v-icon>
                                        <v-icon
                                            v-else-if="task.checked"
                                            color="green"
                                        >
                                            mdi-check-circle
                                        </v-icon>
                                        <v-icon v-else color="red">
                                            mdi-close-circle
                                        </v-icon>
                                    </div>
                                </v-list-item-title>
                                <v-list-item-subtitle
                                    v-if="
                                        !task.loading &&
                                            !task.checked &&
                                            task.reason
                                    "
                                    class="red--text text--darken-1 ml-8"
                                >
                                    {{ task.reason }}
                                </v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn color="grey" text @click="closeValidateGroupDialog">
                        CANCEL
                    </v-btn>
                    <v-btn
                        color="primary"
                        :disabled="validatingGroup"
                        @click="onContinueValidateGroup"
                    >
                        CONTINUE
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="confirmPartialDialog" persistent max-width="480">
            <v-card>
                <v-card-title class="headline">Confirm approval</v-card-title>
                <v-card-text>
                    Not all selected purchases can be approved. Only those that
                    meet the validation criteria will be approved. Do you wish
                    to continue with the allowed purchases?
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn color="grey" text @click="cancelPartialConfirm">
                        Cancel
                    </v-btn>
                    <v-btn
                        color="primary"
                        text
                        @click="confirmPartialAndApprove"
                    >
                        Continue
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="openTimeLine" max-width="500">
            <TimeLinePurchase
                v-if="openTimeLine"
                :request="timeLineRequest"
                :users="users"
                @closeDialog="closeTimeLine"
            />
        </v-dialog>
    </div>
</template>

<script>
import PurchaseRequest from '@/components/Purchasing/PurchaseRequest.vue'
import TimeLinePurchase from '@/components/Purchasing/TimeLinePurchase.vue'
import { firestore } from '@/services/firebase'
import { mapMutations, mapGetters, mapState, mapActions } from 'vuex'
import moment from 'moment'
import API from '@/services/api'
import { getPurchaseApproverLimitInCompanyCurrency } from '@/utils/purchaseApproverLimit.js'
import _ from 'lodash'

export default {
    name: 'PurchasingApproval',
    components: {
        PurchaseRequest,
        TimeLinePurchase,
    },
    props: {
        isPurchaseApprover: {
            type: Boolean,
            default: false,
        },
        purchaseApproverProjects: {
            type: Array,
            default: () => [],
        },
    },
    data: () => ({
        step: 'approval',
        createForm: false,
        selectedRequest: {},
        originalRequest: {},
        openForm: false,
        activateAlert: false,
        alertMessage: '',
        loading: false,
        headers: [
            {
                text: 'ID',
                value: 'number',
                sortable: false,
                align: 'center',
                width: '100px',
            },
            {
                text: 'PROJECT',
                value: 'project',
                sortable: false,
                align: 'center',
            },
            {
                text: 'ITEMS',
                value: 'items',
                sortable: false,
                align: 'center',
            },
            {
                text: 'TOTAL PRICE',
                value: 'totalPrice',
                sortable: false,
                align: 'center',
            },
            {
                text: 'USERS',
                value: 'createdBy',
                sortable: false,
                align: 'center',
            },
            {
                text: 'REQ DATE',
                value: 'date',
                sortable: false,
                align: 'center',
            },
            {
                text: 'DUE DATE',
                value: 'dueDate',
                sortable: false,
                align: 'center',
            },
            {
                text: 'DELIVERY AT',
                value: 'deliveryLocation',
                sortable: false,
                align: 'center',
            },
            {
                text: 'NOTES',
                value: 'notes',
                sortable: false,
                align: 'left',
            },
            {
                text: 'ACTIONS',
                value: 'actions',
                sortable: false,
                align: 'center',
                width: '80px',
            },
        ],
        requests: [],
        users: [],
        usersToFilter: undefined,
        projectToFilter: undefined,
        itemsToFilter: undefined,
        dateToFilter: undefined,
        dueDateToFilter: undefined,
        notesToFilter: undefined,
        locationToFilter: undefined,
        deliveryParamToFilter: undefined,
        companyId: JSON.parse(localStorage.getItem('company')),
        userId: JSON.parse(localStorage.getItem('userId')),
        listener: null,
        foreignTradeListener: null,
        idToFilter: undefined,
        resourceId: undefined,
        localPurchaseApproverProjects: [],
        optionsMenu: [
            {
                title: 'Select different purchases to approve',
                value: 'selectPurchasesToApprove',
                icon: 'mdi-format-list-group-plus',
            },
        ],
        selectedPurchasesToApprove: [],
        validateGroupDialog: false,
        validatingGroup: false,
        validateGroupTasks: [],
        confirmPartialDialog: false,
        purchasesToApproveAfterConfirm: [],
        currentUser: null,
        contacts: [],
        openTimeLine: false,
        timeLineRequest: {},
    }),
    computed: {
        ...mapState(['notificationResource', 'settings']),
        effectivePurchaseApproverProjects() {
            // Usar la prop si está disponible, sino usar la propiedad local
            return this.purchaseApproverProjects &&
                this.purchaseApproverProjects.length > 0
                ? this.purchaseApproverProjects
                : this.localPurchaseApproverProjects
        },
        filterRequests() {
            this.openResource()
            let conditions = []

            if (this.usersToFilter) {
                conditions.push(this.filterForUsers)
            }

            if (this.projectToFilter) {
                conditions.push(this.filterForProject)
            }

            if (this.deliveryParamToFilter) {
                conditions.push(this.filterForDeliveryAt)
            }

            if (this.idToFilter) {
                conditions.push(this.filterForId)
            }

            if (this.itemsToFilter) {
                conditions.push(this.filterForItems)
            }

            if (this.dateToFilter) {
                conditions.push(this.filterForDate)
            }

            if (this.dueDateToFilter) {
                conditions.push(this.filterForDueDate)
            }

            if (this.locationToFilter) {
                conditions.push(this.filterForLocation)
            }

            if (this.notesToFilter) {
                conditions.push(this.filterForNotes)
            }

            if (conditions.length > 0) {
                return this.requests.filter(request => {
                    return conditions.every(condition => {
                        return condition(request)
                    })
                })
            }
            this.sort()
            return this.requests
        },
    },
    watch: {
        notificationResource: function(resource) {
            if (resource) {
                this.resourceId = resource
                this.openResource()
                this.setNotificationResource(undefined)
            }
        },
        purchaseApproverProjects: {
            handler: async function(newVal, oldVal) {
                if (
                    (!oldVal || oldVal.length === 0) &&
                    newVal &&
                    newVal.length > 0
                ) {
                    if (this.listener) {
                        this.loading = true
                        await this.setupFirestoreListener()
                        this.loading = false
                    } else if (!this.listener) {
                        this.loading = true
                        await this.setupFirestoreListener()
                        this.loading = false
                    }
                }
            },
            immediate: false,
        },
    },
    async created() {
        try {
            this.loading = true
            const {
                data: { users },
            } = await API.getLiteUsers()
            this.users = users
        } catch (error) {
            this.setErrorItems({
                source: this.$options.name,
                message: error.message,
            })
        } finally {
            this.loading = false
        }
    },
    async mounted() {
        try {
            this.loading = true
            this.resourceId = this.$route.query.resourceId

            // Si purchaseApproverProjects no viene como prop (recarga directa), cargarlo aquí
            if (
                !this.purchaseApproverProjects ||
                this.purchaseApproverProjects.length === 0
            ) {
                const [
                    {
                        data: { user },
                    },
                    projects,
                ] = await Promise.all([
                    API.getMyInfo(),
                    API.getLiteFreeProjects({ all: true }),
                ])
                for (const project of projects) {
                    if (
                        project.purchaseApprovers &&
                        typeof project.purchaseApprovers === 'object' &&
                        Object.keys(project.purchaseApprovers).includes(user.id)
                    ) {
                        this.localPurchaseApproverProjects.push({
                            id: project.id,
                            limit: project.purchaseApprovers[user.id],
                            currency: project.currency,
                        })
                    }
                }
            }

            // Configurar el listener después de cargar los purchaseApproverProjects
            await this.setupFirestoreListener()
        } catch (error) {
            this.setErrorItems({
                source: this.$options.name,
                message: error.message,
            })
        } finally {
            this.loading = false
        }
    },
    beforeDestroy() {
        if (this.listener) {
            this.listener()
            this.listener = null
        }
        if (this.foreignTradeListener) {
            this.foreignTradeListener()
            this.foreignTradeListener = null
        }
    },
    methods: {
        ...mapMutations(['setErrorItems']),
        ...mapActions(['setNotificationResource']),
        ...mapGetters(['getNotificationResource']),
        formatNumber(number) {
            return new Intl.NumberFormat('de-DE').format(
                Math.ceil(number != undefined ? number : 0)
            )
        },
        async selectFunction(item) {
            if (item.value === 'selectPurchasesToApprove') {
                this.selectedPurchasesToApprove = []
                this.optionsMenu = [
                    {
                        title: 'Validate selected purchases',
                        value: 'validateMultiplePurchases',
                        icon: 'mdi-checkbox-multiple-marked',
                    },
                    {
                        title: 'Cancel selection',
                        value: 'closeGrouping',
                        icon: 'mdi-close-thick',
                    },
                ]
                const checkColumn = {
                    text: 'Select',
                    value: 'select',
                    sortable: false,
                    align: 'center',
                    width: '100px',
                }
                this.headers.unshift(checkColumn)
                return
            } else if (item.value === 'validateMultiplePurchases') {
                await this.groupPurchasesToApprove()
                return
            } else if (item.value === 'closeGrouping') {
                this.closeGroupPurchases()
                return
            }
        },
        async groupPurchasesToApprove() {
            if (!this.selectedPurchasesToApprove.length) {
                this.closeGroupPurchases()
                return
            }
            const selectedRequests = this.requests.filter(r =>
                this.selectedPurchasesToApprove.includes(r.id)
            )
            this.validateGroupDialog = true
            this.validatingGroup = true
            this.validateGroupTasks = selectedRequests.map(req => ({
                name: `Purchase #${req.number || req.id}`,
                icon: 'mdi-cart-outline',
                checked: false,
                loading: true,
                warning: false,
                reason: '',
                request: req,
            }))
            try {
                const [myInfoRes, contactsResponse] = await Promise.all([
                    API.getMyInfo(),
                    this.contacts.length
                        ? Promise.resolve(null)
                        : API.getContacts(),
                ])
                this.currentUser = myInfoRes.data.user
                if (
                    contactsResponse &&
                    contactsResponse.data &&
                    contactsResponse.data.contacts
                ) {
                    this.contacts = contactsResponse.data.contacts.filter(
                        contact => contact.supplierId
                    )
                }
                const userPermissions =
                    (myInfoRes.data.user && myInfoRes.data.user.permissions) ||
                    []
                const finalApprovalPermission = userPermissions.includes(
                    'finalApproval'
                )
                const approveComexServicePermission = userPermissions.includes(
                    'approveComexService'
                )
                for (let i = 0; i < this.validateGroupTasks.length; i++) {
                    const task = this.validateGroupTasks[i]
                    const result = this.canPurchaseBeApproved(
                        task.request,
                        finalApprovalPermission,
                        approveComexServicePermission
                    )
                    this.$set(this.validateGroupTasks, i, {
                        ...task,
                        loading: false,
                        checked: result.allowed,
                        warning: false,
                        reason: result.reason || '',
                    })
                }
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
                this.closeValidateGroupDialog()
            } finally {
                this.validatingGroup = false
            }
        },

        isForeignTradeApprovalQueue(request) {
            return (
                !!request &&
                request.createdOnForeignTrade === true &&
                request.status === 'inProgress'
            )
        },

        canForeignTradePurchaseBeApproved(request) {
            const projectId =
                (request.project && request.project.id) || request.projectId
            const items = (request.items || []).filter(item => item != null)
            if (
                !request.type ||
                !projectId ||
                !request.dueDate ||
                !request.deliveryLocation ||
                !items.length
            ) {
                return {
                    allowed: false,
                    reason: 'Incomplete required fields',
                }
            }
            return { allowed: true }
        },

        canPurchaseBeApproved(
            request,
            finalApprovalPermission,
            approveComexServicePermission
        ) {
            // This tab lists regular purchases in `approval` and COMEX
            // purchases that wait for approveComexService in `inProgress`.
            const isForeignTradeQueue = this.isForeignTradeApprovalQueue(
                request
            )
            if (
                !request ||
                (request.status !== 'approval' && !isForeignTradeQueue)
            ) {
                return { allowed: false, reason: 'Not in approval status' }
            }
            if (isForeignTradeQueue) {
                if (!approveComexServicePermission) {
                    return {
                        allowed: false,
                        reason: 'No COMEX approval permission',
                    }
                }
                return this.canForeignTradePurchaseBeApproved(request)
            }
            const projectId =
                (request.project && request.project.id) || request.projectId
            if (!projectId) {
                return { allowed: false, reason: 'Missing project' }
            }
            const totalNoTax = Number(
                request.totalPrice != null && request.totalPrice !== ''
                    ? request.totalPrice
                    : this.calculateTotal(request) || 0
            )
            const isPurchaseApprover =
                this.effectivePurchaseApproverProjects &&
                this.effectivePurchaseApproverProjects.length > 0
            if (finalApprovalPermission) {
                // same validations as PurchaseRequest enableButton for approval
            } else if (isPurchaseApprover) {
                const approverProject = this.effectivePurchaseApproverProjects.find(
                    p => p.id === projectId
                )
                if (!approverProject || !approverProject.limit) {
                    return {
                        allowed: false,
                        reason: 'No approval limit for this project',
                    }
                }
                const approverLimit = this.getApproverLimitForProject(
                    approverProject
                )
                if (totalNoTax > approverLimit) {
                    return {
                        allowed: false,
                        reason: 'Exceeds approval limit',
                    }
                }
            } else {
                return { allowed: false, reason: 'No approval permission' }
            }
            const hasQuotes = this.requestQuotesForRequest(request)
            if (!hasQuotes) {
                return { allowed: false, reason: 'Missing quote files' }
            }
            if (this.validateQuotesForRequest(request)) {
                return {
                    allowed: false,
                    reason: 'Missing selected quotes',
                }
            }
            if (this.validateImportItemsForRequest(request)) {
                return {
                    allowed: false,
                    reason: 'Import items incomplete',
                }
            }
            if (request.importation && request.incoterm == null) {
                return { allowed: false, reason: 'Missing incoterm' }
            }
            return { allowed: true }
        },

        getApproverLimitForProject(approverProject) {
            if (!approverProject || !approverProject.limit) return 0
            return getPurchaseApproverLimitInCompanyCurrency(
                approverProject.limit,
                this.settings,
                approverProject.currency
            )
        },

        validateQuotesForRequest(request) {
            const items = (request.items || []).filter(item => item != null)
            if (!items.length) return true
            for (const item of items) {
                if (!item.quotes || item.quotes.length === 0) return true
                if (!item.quotes.find(q => q.able)) return true
            }
            return false
        },

        requestQuotesForRequest(request) {
            if (
                request.quotes &&
                Array.isArray(request.quotes) &&
                request.quotes.length > 0
            ) {
                return true
            }
            if (!request.items || !request.items.length) return false
            return request.items.every(
                item =>
                    item &&
                    item.quotes &&
                    Array.isArray(item.quotes) &&
                    item.quotes.length > 0
            )
        },

        validateImportItemsForRequest(request) {
            if (!request || request.importation !== true) return false
            return !(
                Array.isArray(request.items) &&
                request.items.some(item => item && item.isImportation === true)
            )
        },

        closeValidateGroupDialog() {
            this.validateGroupDialog = false
            this.validateGroupTasks = []
            this.purchasesToApproveAfterConfirm = []
            this.confirmPartialDialog = false
            this.closeGroupPurchases()
        },

        onValidateGroupDialogClose(val) {
            if (!val) {
                this.validateGroupTasks = []
                this.purchasesToApproveAfterConfirm = []
                this.confirmPartialDialog = false
            }
        },

        async onContinueValidateGroup() {
            const allowed = this.validateGroupTasks
                .filter(t => t.checked)
                .map(t => t.request)
            const notAllowed = this.validateGroupTasks.filter(t => !t.checked)
                .length
            if (allowed.length === 0) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: 'No selected purchases can be approved.',
                })
                return
            }
            if (notAllowed > 0) {
                this.purchasesToApproveAfterConfirm = allowed
                this.confirmPartialDialog = true
                return
            }
            this.closeValidateGroupDialog()
            await this.executeGroupApprove(allowed)
        },

        cancelPartialConfirm() {
            this.confirmPartialDialog = false
            this.closeValidateGroupDialog()
        },

        async confirmPartialAndApprove() {
            const toApprove = [...this.purchasesToApproveAfterConfirm]
            this.confirmPartialDialog = false
            this.closeValidateGroupDialog()
            await this.executeGroupApprove(toApprove)
        },

        getRejectedSuppliersInfo(request) {
            const acceptedSuppliers = new Set()
            const allSuppliersWithQuotes = new Set()
            let rejectedSuppliersInfo = []
            if (request.items) {
                request.items.forEach(item => {
                    if (item && item.quotes) {
                        item.quotes.forEach(quote => {
                            const supplierId =
                                quote.supplier && quote.supplier.id
                            if (!supplierId) return
                            allSuppliersWithQuotes.add(supplierId)
                            if (quote.able && quote.able === true) {
                                acceptedSuppliers.add(supplierId)
                            }
                        })
                    }
                })
                const rejectedSupplierIds = [...allSuppliersWithQuotes].filter(
                    id => !acceptedSuppliers.has(id)
                )
                if (rejectedSupplierIds.length > 0) {
                    rejectedSuppliersInfo = rejectedSupplierIds
                        .map(supplierIdInfo => {
                            const contact = this.contacts.find(
                                c => c.supplierId === supplierIdInfo
                            )
                            if (!contact || !contact.email) return undefined
                            return {
                                supplierId: supplierIdInfo,
                                supplierEmail: contact.email,
                            }
                        })
                        .filter(Boolean)
                }
            }
            return rejectedSuppliersInfo
        },

        buildApprovePayload(request) {
            const rejectedSuppliersInfo = this.getRejectedSuppliersInfo(request)
            const requestDiff = {}
            requestDiff.status = 'purchasing'
            if (rejectedSuppliersInfo.length > 0) {
                requestDiff.suppliersRejected = rejectedSuppliersInfo
            }
            delete requestDiff.quotes
            delete requestDiff.purchaseOrders
            delete requestDiff.attachments
            delete requestDiff.items
            delete requestDiff.totalPrice
            delete requestDiff.createdBy
            return {
                notificationId: 'XqRU6KwrWOypCwgHQxbu',
                ...requestDiff,
            }
        },

        async executeGroupApprove(purchases) {
            if (!purchases.length) return
            try {
                this.loading = true
                await Promise.all(
                    purchases.map(p => {
                        const payload = this.buildApprovePayload(p)
                        return API.updatePurchaseRequest(p.id, payload)
                    })
                )
                this.alertMessage =
                    purchases.length === 1
                        ? 'Purchase was successfully approved'
                        : `${purchases.length} purchases were successfully approved`
                this.activateAlert = true
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loading = false
            }
        },

        closeGroupPurchases() {
            this.headers.shift()
            this.selectedPurchasesToApprove = []
            this.optionsMenu = [
                {
                    title: 'Select different purchases to approve',
                    value: 'selectPurchasesToApprove',
                    icon: 'mdi-format-list-group-plus',
                },
            ]
        },

        rejectRequest() {
            this.alertMessage = 'Purchase was rejected'
            this.activateAlert = true
            this.closeRequestForm()
        },
        filterForId(item) {
            return item.number.toString().includes(this.idToFilter)
        },
        formatDate(seconds) {
            return moment.unix(seconds).format('YYYY-MM-DD')
        },
        approveForPurchase() {
            this.alertMessage = 'Purchase was successfully Approved'
            this.activateAlert = true
            this.openForm = false
        },
        sendToApproval() {
            this.alertMessage = 'Purchase was successfully sent to Approval'
            this.activateAlert = true
            this.openForm = false
        },
        filterForDeliveryAt(item) {
            return (
                item.deliveryAt &&
                item.deliveryAt
                    .toLowerCase()
                    .includes(this.deliveryParamToFilter.toLowerCase())
            )
        },
        filterForProject(item) {
            return (
                item.project &&
                item.project.name
                    .toLowerCase()
                    .includes(this.projectToFilter.toLowerCase())
            )
        },
        filterForUsers(item) {
            return (
                (item.createdBy.name &&
                    item.createdBy.name
                        .toLowerCase()
                        .includes(this.usersToFilter.toLowerCase())) ||
                (item.projectManager.name &&
                    item.projectManager.name
                        .toLowerCase()
                        .includes(this.usersToFilter.toLowerCase())) ||
                (item.buyer &&
                this.users.find(user => user.id == item.buyer) != undefined
                    ? this.users
                          .find(user => user.id == item.buyer)
                          .name.toLowerCase()
                          .includes(this.usersToFilter.toLowerCase())
                    : false)
            )
        },

        filterForItems(item) {
            return item.items.some(
                i =>
                    i.description &&
                    i.description
                        .toLowerCase()
                        .includes(this.itemsToFilter.toLowerCase())
            )
        },
        filterForDate(item) {
            const date = this.formatDate(
                item.createdOn.seconds
                    ? item.createdOn.seconds
                    : item.createdOn._seconds
            )
            return date.includes(this.dateToFilter)
        },
        filterForDueDate(item) {
            return item.dueDate.includes(this.dueDateToFilter)
        },
        filterForNotes(item) {
            return (
                item.notes &&
                item.notes
                    .toLowerCase()
                    .includes(this.notesToFilter.toLowerCase())
            )
        },
        filterForLocation(item) {
            return (
                item.deliveryLocation &&
                item.deliveryLocation
                    .toLowerCase()
                    .includes(this.locationToFilter.toLowerCase())
            )
        },
        getUser(id) {
            const user = this.users.find(u => u.id == id)
            if (user) {
                return user.name
            }
            return null
        },
        openRequest(request) {
            this.selectedRequest = { ...request }
            this.originalRequest = { ...request }
            this.openForm = true
        },
        openTimeLineDialog(request) {
            this.timeLineRequest = _.cloneDeep(request)
            this.openTimeLine = true
        },
        closeTimeLine() {
            this.openTimeLine = false
            this.timeLineRequest = {}
        },
        closeRequestForm() {
            this.openForm = false
            this.selectedRequest = {}
            this.originalRequest = {}
        },
        replaceRequest() {},
        openResource() {
            if (this.resourceId) {
                const resource = this.requests.find(
                    r => r.id == this.resourceId
                )
                if (resource) {
                    this.resourceId = undefined
                    this.openRequest(resource)
                }
            }
        },
        sort() {
            this.requests.sort(
                (a, b) => b.createdOn.seconds - a.createdOn.seconds
            )
        },
        calculateTotal(request) {
            let calculatedTotal = 0
            request.items = request.items ? request.items : []
            request.items.forEach(i => {
                if (!i) return
                i.quotes = i.quotes ? i.quotes : []
                i.quotes.forEach(q => {
                    if (q.able) {
                        calculatedTotal +=
                            Number(i.quantity || 0) *
                            Number(
                                q.unitPriceNoTaxBeforeTRM ??
                                    q.unitPriceNoTax ??
                                    q.priceBeforeTRM ??
                                    q.price ??
                                    0
                            )
                    }
                })
            })
            return calculatedTotal
        },
        async setupFirestoreListener() {
            try {
                if (this.listener) {
                    this.listener()
                    this.listener = null
                }
                if (this.foreignTradeListener) {
                    this.foreignTradeListener()
                    this.foreignTradeListener = null
                }
                this.requests = []

                const {
                    data: { user },
                } = await API.getMyInfo()
                const hasApproveComexServicePermission = user.permissions.includes(
                    'approveComexService'
                )

                console.log(
                    'hasApproveComexServicePermission',
                    hasApproveComexServicePermission
                )

                let approvalQuery = firestore
                    .collection('companies')
                    .doc(this.companyId)
                    .collection('purchases')
                    .where('status', '==', 'approval')

                this.listener = await approvalQuery.onSnapshot(
                    async docSnapshot => {
                        docSnapshot.docChanges().forEach(async change => {
                            const request = Object.assign(change.doc.data(), {
                                id: change.doc.id,
                            })

                            const canSeeRequest =
                                user.permissions.includes('finalApproval') ||
                                (this.effectivePurchaseApproverProjects &&
                                    this.effectivePurchaseApproverProjects
                                        .length > 0 &&
                                    this.effectivePurchaseApproverProjects.some(
                                        p => {
                                            return (
                                                p.id === request.project?.id &&
                                                Number(
                                                    this.calculateTotal(
                                                        request
                                                    ) || 0
                                                ) <=
                                                    Number(
                                                        this.getApproverLimitForProject(
                                                            p
                                                        ) || 0
                                                    )
                                            )
                                        }
                                    ))

                            if (!canSeeRequest) {
                                return
                            }

                            if (change.type === 'added') {
                                request.dueDate = this.formatDate(
                                    request.dueDate.seconds
                                )
                                this.requests.push(request)
                            }
                            if (change.type === 'modified') {
                                request.dueDate = this.formatDate(
                                    request.dueDate.seconds
                                )
                                const index = this.requests.findIndex(
                                    r => r.id == request.id
                                )
                                if (index >= 0) {
                                    this.requests.splice(index, 1, request)
                                }
                            }
                            if (change.type === 'removed') {
                                this.removeRequestById(request.id)
                            }
                        })
                    }
                )

                if (hasApproveComexServicePermission) {
                    const foreignTradeQuery = firestore
                        .collection('companies')
                        .doc(this.companyId)
                        .collection('purchases')
                        .where('status', '==', 'inProgress')

                    this.foreignTradeListener = await foreignTradeQuery.onSnapshot(
                        async docSnapshot => {
                            docSnapshot.docChanges().forEach(async change => {
                                const request = Object.assign(
                                    change.doc.data(),
                                    {
                                        id: change.doc.id,
                                    }
                                )

                                if (request.createdOnForeignTrade !== true) {
                                    this.removeRequestById(request.id)
                                    return
                                }

                                if (change.type === 'added') {
                                    request.dueDate = this.formatDate(
                                        request.dueDate.seconds
                                    )
                                    this.requests.push(request)
                                }
                                if (change.type === 'modified') {
                                    request.dueDate = this.formatDate(
                                        request.dueDate.seconds
                                    )
                                    const index = this.requests.findIndex(
                                        r => r.id == request.id
                                    )
                                    if (index >= 0) {
                                        this.requests.splice(index, 1, request)
                                    } else {
                                        this.requests.push(request)
                                    }
                                }
                                if (change.type === 'removed') {
                                    this.removeRequestById(request.id)
                                }
                            })
                        }
                    )
                }
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            }
        },
        removeRequestById(requestId) {
            const index = this.requests.findIndex(r => r.id == requestId)
            if (index >= 0) {
                this.requests.splice(index, 1)
            }
        },
    },
}
</script>

<style scoped>
.v-data-table {
    border: 1px solid #eeeeee;
}
thead {
    background: #eeeeee;
    position: sticky;
    z-index: 1;
}
.v-input .v-label {
    font-size: 12px;
}
.v-data-table-header th {
    background-color: #eeeeee !important;
}
.v-data-table__wrapper {
    max-height: 72vh;
    overflow-y: auto;
}
.v-data-table__row {
    height: 6vh;
}
.v-data-table__wrapper thead tr {
    position: sticky;
    top: 0;
    z-index: 10;
}
.purchasing-approval-menu >>> .v-menu__content {
    z-index: 2000 !important;
}
</style>
